import findIndex from 'lodash/findIndex'

import { PotentialDropTarget } from '../types'

export const updateValue = ({
	value,
	movable,
	dropTarget
}: {
	value: LabelValue<number>[]
	movable: string
	dropTarget: PotentialDropTarget
}) => {
	const movableItem = value.find((v) => v.value.toString() === movable)

	let indexToInsert = findIndex(value, function (v) {
		return v.value.toString() === dropTarget.dropTarget
	})

	indexToInsert = dropTarget.isAfter ? ++indexToInsert : indexToInsert

	const valueWithPlaceholder = value.map((v) => {
		if (v.value.toString() === movable) {
			return null
		}

		return v
	})

	if (indexToInsert === 0) {
		return [movableItem, ...valueWithPlaceholder].filter(Boolean)
	}

	if (indexToInsert === valueWithPlaceholder.length) {
		return [...valueWithPlaceholder, movableItem].filter(Boolean)
	}

	const result = [
		...valueWithPlaceholder.slice(0, indexToInsert),
		movableItem,
		...valueWithPlaceholder.slice(indexToInsert)
	].filter(Boolean)

	return result
}
